import { render } from "./MenuHead.vue?vue&type=template&id=7f980360"
import script from "./MenuHead.vue?vue&type=script&lang=js"
export * from "./MenuHead.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__